<template>
	<section>
		<header-page
			name="access-by-role"
			:title="$route.meta.title"
		/>
		<general-filter class="mt-4">
			<v-layout row wrap align-center>
				<v-flex xs3 pr-2>
					<v-select
						background-color="white"
						box
						class="body-1"
						hide-details
						item-text="name"
						item-value="codeApp"
						:items="apps"
						label="Aplicaciones"
						v-model="codeApp"
						@input="listModules"
					>
					</v-select>
				</v-flex>
				<v-flex xs2 pl-2>
					<v-btn
						color="success"
						class="btn-action caption"
						:disabled="!codeApp"
						@click="openModal"
					>
						<v-icon>add</v-icon>
						Módulos
					</v-btn>
				</v-flex>
			</v-layout>
		</general-filter>
		<general-filter class="mt-4">
			<v-layout row wrap>
				<v-flex xs12>
					<v-chip
						close
						v-for="chip in chips"
						:key="chip.id"
						@input="deleteResource(chip.id, chip.name)"
					>
						{{ chip.name }}
					</v-chip>
				</v-flex>
			</v-layout>
		</general-filter>
		<v-layout wrap>
			<v-flex xs12 class="table-padding">
				<role-access-resource-list
					:columns="columns"
					:check-all="checkAll"
					:rows="rows"
					:code-company="codeCompany"
					:code-project="codeProject"
					:check-row="checkRow"
					@all-is-selected="allIsSelected"
					@on-search="onSearchResource"
					@open-settings="openSettings"
					@open-actions="openActions"
					@open-subresources="openSubresources"
					@open-services="openServices"
					@row-is-selected="rowIsSelected"
				/>
			</v-flex>
		</v-layout>
		<v-layout wrap>
			<section class="modal-filter-footer">
				<v-flex xs12>
					<modal-sidebar-button
						:is-loading="disabledSave"
						:on-run-service="assignLoading"
						@accept-button-clicked="saveRole"
						@cancel-button-clicked="cancel"
					/>
				</v-flex>
			</section>
		</v-layout>
		<action-sidebar
			:title="action.title"
			:value="action.value"
			@close-modal="closeModal"
		>
			<role-access-module-form
				v-if="actionModules"
				:code-app="codeApp"
			 	:code-company="codeCompany"
				:code-project="codeProject"
				:is-selected="isSelected"
				:loading="loading"
				:role-id="roleId"
			 	:role-name="roleName"
				@on-search="onSearch"
				@save-selection="showSelection"
				@close-modal="closeModal"
			/>
			<role-access-configuration
				v-if="actionSettings"
				:code-company="codeCompany"
				:code-project="codeProject"
				:id="id"
				:rows="rowSelect"
				@close-modal="closeModal"
			/>
			<role-access-subresource-form
				v-if="actionSubresources"
				:loading="subresourceLoading"
				:modules-id="modulesId"
				:resource-id="resourceId"
				:resource-name="resourceName"
				@close-modal="closeModal"
				@send-selection="assignSubresources"
			/>
			<role-access-action
				v-if="actionAssignActionBar"
				:resource-id="resourceId"
				:code-project="codeProject"
				:resource-name="resourceName"
				:role-id="roleId"
				@close-modal="closeModal"
			/>
			<role-access-services 
				v-if="actionServices"
				:resource-id="resourceId"
				:resource-name="resourceName"
				:resource-permission="resourcePermission"
				:role-id="roleId"
				@save-services="saveServices"
				@close-modal="closeModalServices"
			/>
		</action-sidebar>
	</section>
</template>

<script>
	import actionSidebar from '@/components/shared/action-sidebar';
	import roleAccessConfiguration from '@/components/roles/role-access-configuration';
	import roleAccessModuleForm from '@/components/roles/role-access-module-form';
	import roleAccessResourceList from '@/components/roles/role-access-resource-list';
	import roleAccessSubresourceForm from '@/components/roles/role-access-subresource-form';
	import roleAccessAction from '@/components/roles/role-access-action';
	import roleAccessServices from '@/components/roles/role-access-services';

	function created() {
		this.loadApps();
	}

	function actionModules() {
		return this.action.code === 'MOD';
	}

	function actionSettings() {
		return this.action.code === 'SETTINGS';
	}

	function actionSubresources() {
		return this.action.code === 'SRC';
	}

	function allIsSelected(checked) {
		this.checkAll = checked;
		this.resources = [];
		this.rows = this.selectIsRow(this.rows, 'isSelected', false, checked, 'status');
	}

	async function assignSubresources({ subresources, resourceId }) {
		const headers = {
			Accept: `${process.env.ACCEPT_SERVICE_V2}`,
		};
		const body = {
			id: resourceId,
			resourcesId: subresources.map(({ id, isSelected }) => ({ id, isSelected })),
		};
		this.subresourceLoading = true;
		try {
			await this.$http.post('resources-levels', body, { headers });
			this.showNotification('Los subrecursos han sido asignados correctamente.');
		} catch (err) {
			if (err.status === 500) {
				this.showError();
			} else if (err.status === 400) {
				if (err.data.resourcesId) {
					this.showNotification('La lista de recursos es requerida.', 'error');
				}
			}
		} finally {
			this.subresourceLoading = false;
		}
	}

	function closeModal() {
		if (this.action.code === 'ASSIGN-SERVICES') {
			this.closeModalServices();
		} else {
			this.action.code = '';
			this.action.value = false;
			this.action.title = '';
			this.loadResource();
		}
	}

	function deleteResource(idSelect, nameSelect) {
		this.resourcesDelete =
			this.rows.filter(element => element.module === nameSelect && element.status === 1);
		this.resourcesDelete = this.resourcesDelete.map(element => element.id);
		this.chips.forEach((element, index) => {
			if (element.id === idSelect) {
				this.chips.splice(index, 1);
				this.loadResource();
			}
		});
	}

	function disabledSave() {
		return this.rows.length === 0 || this.assignLoading;
	}

	async function listModules() {
		const params = {
			page: 1,
			perPage: 20,
			codeApp: this.codeApp,
			roleId: this.roleId,
		};
		const headers = {
			Accept: `${process.env.ACCEPT_SERVICE_V2}`,
		};
		const response = await this.$http.get(`project/${this.codeProject}/company/${this.codeCompany}/modules`,
			{ params, headers });
		this.chips = response.data.data;
		this.resourcesDelete = [];
		this.loadResource();
	}

	async function loadApps() {
		const headers = {
			Accept: `${process.env.ACCEPT_SERVICE_V2}`,
		};
		const { data: apps } = await this.$http.get(`project/${this.codeProject}/company/${this.codeCompany}/apps`,
			{ headers });
		this.apps = apps.data;
	}

	async function loadResource(value = '') {
		const arraySelect = [];
		this.chips.forEach((element) => {
			arraySelect.push(element.id);
		});
		const params = {
			modulesId: arraySelect.join(),
			roleId: this.roleId,
			search: value || null,
		};
		const headers = {
			Accept: `${process.env.ACCEPT_SERVICE_V2}`,
		};
		this.loading = true;
		if (this.chips.length > 0) {
			try {
				const { data: rows } = await this.$http.get('resources-permission', { params, headers });
				this.rows = rows.data.map((element) => {
					const newElement = { ...element };
					newElement.statusName = element.status ? 'Agregado' : 'No Agregado';
					newElement.configLanguages = element.configLanguages ? element.configLanguages : '';
					newElement.resource = element.resource ? element.resource.data.name : '';
					newElement.module = element.module ? element.module.data.name : '';
					newElement.disabled = !newElement.configLanguages;
					newElement.isSelected = this.checkAll ? newElement.status > 0 : this.checkRow;
					newElement.configPosition = element.configLanguages ? element.configLanguages.position
						: null;
					return newElement;
				});
				this.checkAll = this.rows.some(element => element.status === 1);
				this.allIsSelected(this.checkAll);
			} catch (err) {
				this.showError();
			} finally {
				this.loading = false;
				this.modulesId = params.modulesId;
			}
		} else {
			this.loading = false;
			this.rows = [];
		}
	}

	function onSearch(value) {
		this.params.code = value;
		this.loadData(`app/${this.codeApp}/modules`);
	}

	function openModal() {
		this.action.code = 'MOD';
		this.action.value = true;
		this.action.title = 'MÓDULOS';
	}

	function openSettings(id) {
		this.id = id;
		this.rows.forEach((element) => {
			if (element.id === id) {
				this.rowSelect = element;
			}
		});
		this.action.code = 'SETTINGS';
		this.action.value = true;
		this.action.title = 'Configuración';
	}

	function openSubresources({ id, name }) {
		this.resourceId = id;
		this.resourceName = name;
		this.action.code = 'SRC';
		this.action.title = 'SUB RECURSOS';
		this.action.value = true;
	}

	function rowIsSelected(row) {
		this.checkRow = row.isSelected;
		this.rows = this.selectIsRow(this.rows, 'isSelected', row);
		this.checkAll = this.every(this.rows.filter(element => element.status === 1));
	}

	function showSelection(modules) {
		this.chips = Object.assign([], modules);
		this.loadResource();
	}

	function cancel() {
		this.goTo('page-role');
	}

	async function saveRole() {
		const resources = this.rows.map((element) => {
			const newSelect = {};
			newSelect.id = element.id;
			newSelect.isSelected = element.isSelected;
			newSelect.permission = element.permission || {};
			return newSelect;
		});
		this.resourcesDelete.forEach((element) => {
			const newSelect = {};
			newSelect.id = element;
			newSelect.isSelected = false;
			resources.push(newSelect);
		});
		const headers = {
			Accept: `${process.env.ACCEPT_SERVICE_V2}`,
		};
		this.assignLoading = true;
		try {
			await this.$http.post(`role/${this.roleId}/resource`, { resources }, { headers });
			this.showNotification('Los permisos han sido asignados correctamente.');
			this.loadResource();
		} catch (err) {
			this.showError();
		} finally {
			this.assignLoading = false;
		}
	}

	function onSearchResource(value) {
		this.loadResource(value);
	}

	function actionAssignActionBar() {
		return this.action.code === 'ASSIGN-ACTION-BAR';
	}

	function openActions({ id, name }) {
		this.resourceId = id;
		this.resourceName = name;
		this.action.code = 'ASSIGN-ACTION-BAR';
		this.action.title = 'ASIGNAR BARRA DE ACCIONES';
		this.action.value = true;
	}

	function openServices({ id, name, permission }) {
		this.resourceId = id;
		this.resourceName = name;
		this.resourcePermission = permission || {};
		this.action.code = 'ASSIGN-SERVICES';
		this.action.title = 'ASIGNAR SERVICIOS';
		this.action.value = true;
	}

	function actionServices() {
		return this.action.code === 'ASSIGN-SERVICES';
	}

	function saveServices(services, id) {
		const index = this.rows.findIndex(r => r.id === id);
		if (index > -1) {
			const selects = services.filter(s => s.isSelected);
			if (selects.length) {
				this.rows[index].permission = selects.reduce((acum, item) => {
					const newAcum = { ...acum };
					newAcum[item.id] = item.authorize;
					return newAcum;
				}, {});
			} else {
				this.rows[index].permission = {};
			}
		}
		this.showNotification('Los servicios han sido asignados correctamente.');
		this.closeModalServices();
	}

	function closeModalServices() {
		this.action.code = '';
		this.action.value = false;
		this.action.title = '';
	}

	function data() {
		return {
			action: {
				code: '',
				title: '',
				value: false,
			},
			apps: [],
			assignLoading: false,
			checkAll: false,
			checkRow: false,
			chips: [],
			codeApp: '',
			columns: [
				{ id: 1, name: 'Nombre', checked: true, visible: true },
				{ id: 2, name: 'URL', checked: true, visible: true },
				{ id: 3, name: 'Recurso Padre', checked: true, visible: true },
				{ id: 4, name: 'Módulo', checked: true, visible: true },
				{ id: 5, name: 'Posición', checked: true, visible: true },
				{ id: 6, name: 'Estado', checked: true, visible: true },
				{ id: 7, name: 'Acciones', checked: true, visible: true, flagVisible: true },
			],
			currentPage: 1,
			id: 0,
			isSelected: 1,
			loading: false,
			modulesId: '',
			resourceId: 0,
			resourceName: '',
			resourcePermission: {},
			rows: [],
			resourcesDelete: [],
			rowSelect: {},
			subresourceLoading: false,
		};
	}

	export default {
		name: 'page-access-role',
		components: {
			actionSidebar,
			roleAccessConfiguration,
			roleAccessModuleForm,
			roleAccessResourceList,
			roleAccessSubresourceForm,
			roleAccessAction,
			roleAccessServices,
		},
		computed: {
			actionAssignActionBar,
			actionModules,
			actionSettings,
			actionSubresources,
			actionServices,
			disabledSave,
		},
		created,
		data,
		methods: {
			allIsSelected,
			assignSubresources,
			cancel,
			closeModal,
			deleteResource,
			listModules,
			loadApps,
			loadResource,
			onSearch,
			onSearchResource,
			openActions,
			openModal,
			openServices,
			openSettings,
			openSubresources,
			rowIsSelected,
			saveRole,
			showSelection,
			saveServices,
			closeModalServices,
		},
		props: {
			codeCompany: {
				type: String,
			},
			roleId: {
				type: [Number, String],
			},
			roleName: {
				type: String,
			},
			codeProject: {
				type: String,
			},
		},
	};
</script>



// WEBPACK FOOTER //
// src/pages/roles/page-role-access.vue